import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailySubcontract/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function addObjBuild (obj) {
  return axios({
    url: '/dailySubcontract/saveBuild',
    method: 'POST',
    data: obj
  })
}
export function addObjCuring (obj) {
  return axios({
    url: '/dailySubcontract/saveCuring',
    method: 'POST',
    data: obj
  })
}

export function delObj (id) {
  return axios({
    url: `/dailySubcontract/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/dailySubcontract/${id}`,
    method: 'GET'
  })
}
export function putObj (params) {
  return axios({
    url: `/dailySubcontract/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

// 导出成本统计
export function download (params) {
  return axios({
    url: '/dailySubcontract/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
